import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash';

import { moduleName } from '../constants';
import reducers from './reducersTyped';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const moduleSel = (state: any): ReturnType<typeof reducers> =>
  get(state, moduleName);

export const leadershipEditModeSel = createSelector(
  moduleSel,
  ({ leadershipEditMode }) => leadershipEditMode,
);

export const updatePositionsModalVisibleSel = createSelector(
  moduleSel,
  ({ updatePositionsModalVisible }) => updatePositionsModalVisible,
);

export const deletePositionModalVisibleSel = createSelector(
  moduleSel,
  ({ deletePositionModalVisible }) => deletePositionModalVisible,
);

export const positionToUpdateSel = createSelector(
  moduleSel,
  ({ positionToUpdate }) => positionToUpdate,
);
